import * as React from 'react'
import { connect } from 'react-redux'
import * as moment from 'moment'
import './Footer.css'

class Footer extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }
    render() {
        return (
            <div className="footer">
                <div className="footer-container">
                    六度智囊 © {moment().year()}
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        width: state.width,
    }
}

export default connect(mapStateToProps, {})(Footer)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Footer/index.tsx